import { FlowType } from '../../store/models/flow-type';

export const FLOW_PROCESS_EGON: {
    [key in FlowType]?: string[];
} = {
    [FlowType.Voltura]: ['Vendita'],
    [FlowType.VolturaAmmVip]: ['Vendita'],
    [FlowType.VolturaAmmNoProvisioning]: ['Vendita'],
    [FlowType.VolturaAmmSiProvisioning]: ['Vendita'],
    [FlowType.VolturaAmmIncorporazioneSocietaria]: ['Vendita'],
    [FlowType.Attivazione]: ['Vendita'],
    [FlowType.AttivazioneGas]: ['Vendita'],
    [FlowType.AttivazioneN02]: ['Vendita'],
    [FlowType.AttivazionePwrS01]: ['Vendita'],
    [FlowType.AttivazioneA40]: ['Vendita'],
    [FlowType.AttivazionePwrA01]: ['Vendita'],
    [FlowType.AttivazionePN1]: ['Vendita'],
    [FlowType.AttivazioneAmmGasA01]: ['Vendita'],
    [FlowType.AttivazioneAmmPwrS01]: ['Vendita'],
    [FlowType.AttivazioneAmmVipPowerS01]: ['Vendita'],
    [FlowType.AttivazioneAmmVipGasA01]: ['Vendita'],
    [FlowType.AttivazioneAmmRecuperoS01]: ['Vendita'],
    [FlowType.AttivazioneAmmRecuperoA01]: ['Vendita'],
    [FlowType.AttivazioneAmmA40]: ['Vendita'],
    [FlowType.AttivazioneAmmPN1]: ['Vendita'],
    [FlowType.AttivazionePwrAmmA01]: ['Vendita'],
    [FlowType.AttivazioneAmmN02]: ['Vendita'],
    [FlowType.AttivazioneVipA40]: ['Vendita'],
    [FlowType.AttivazioneVipPN1]: ['Vendita'],
    [FlowType.AttivazionePwrVipA01]: ['Vendita'],
    [FlowType.AttivazioneVipN02]: ['Vendita'],
    [FlowType.AttivazionePwrA01Old]: ['Vendita'],
    [FlowType.AttivazionePwrAmmA01Old]: ['Vendita'],
    [FlowType.AttivazionePwrVipA01Old]: ['Vendita'],
    [FlowType.VolturaCambioFornitore]: ['Vendita'],
    [FlowType.VolturaCambioFornitoreVip]: ['Vendita'],
    [FlowType.VolturaCambioFornitoreAmmRecupero2C]: ['Vendita'],
    [FlowType.VolturaCambioFornitoreAmmRecupero2B]: ['Vendita'],
    [FlowType.VolturaCambioFornitoreAmmRecupero2A]: ['Vendita'],
    [FlowType.ExtraCommoditySale]: ['Vendita'],
    [FlowType.SwitchInAmmVip]: ['Vendita'],
    [FlowType.SwitchIn]: ['Vendita'],
    [FlowType.SwitchInAmmDelibera153]: ['Vendita'],
    [FlowType.SwitchInAmmRecupero2C]: ['Vendita'],
    [FlowType.SwitchInAmmRecupero2B]: ['Vendita'],
    [FlowType.SwitchInAmmRecupero2A]: ['Vendita'],
    [FlowType.CPCommerciale]: ['Vendita'],
    [FlowType.CPRetroattivoAssetCessato]: ['Vendita'],
    [FlowType.Cessazione]: ['PostVendita'],
    [FlowType.CessazioneAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneIndirizzo]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavori]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivo]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoVariazioneFasi]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoVariazioneFasiAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoVariazioneTensione]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoVariazioneTensioneAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoModificaImpianto]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoModificaImpiantoAmministrativa]: ['PostVendita'],
    [FlowType.VariazioneTecnicaLavoriPreventivoAumentoPotenza]: ['PostVendita']
};
